export default __webpack_public_path__ + "155c3bf42fec267cc125af0a38642828.svg";